import type React from "react"
import { Box, Container, Typography, Grid } from "@mui/material"
import StepCard from "../molecules/StepCard"
import LooksOneIcon from "@mui/icons-material/LooksOne"
import LooksTwoIcon from "@mui/icons-material/LooksTwo"
import Looks3Icon from "@mui/icons-material/Looks3"

interface Step {
  icon: React.ReactNode
  title: string
  description: string
}

const steps: Step[] = [
  {
    icon: <LooksOneIcon fontSize="large" />,
    title: "Post Your Requirement",
    description: "Share your specific needs, preferences, and budget for the perfect match.",
  },
  {
    icon: <LooksTwoIcon fontSize="large" />,
    title: "Get Verified Responses",
    description: "Receive responses from verified cooks and maids who match your requirements.",
  },
  {
    icon: <Looks3Icon fontSize="large" />,
    title: "Hire with Confidence",
    description: "Connect directly, interview, and hire the perfect candidate for your home.",
  },
]

const HowItWorksSection: React.FC = () => {
  return (
    <Box id="how-it-works" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h2" component="h2" gutterBottom>
            How It Works
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 700, mx: "auto" }}>
            Finding the perfect cook or maid is just three simple steps away
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid item xs={12} md={4} key={index}>
              <StepCard icon={step.icon} title={step.title} description={step.description} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default HowItWorksSection
